<template>
  <div :class="['custom-overlay', {animate: animate}]" v-show="visible">
    <div class="dialog-card" :class="{center:center}">
      <div v-if="showClose" class="btn-close" @click="$emit('update:visible', false)"><img class="icon" src="https://resource.rcclchina.com.cn/global/icons/iconCloseWhite.png" alt="" /></div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseDialog',

  props: {
    visible: Boolean,
    showClose:{
      type:Boolean,
      default:true
    },
    center:{
      type:Boolean,
      default:false
    }

  },

  data () {
    return {
      animate: false
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.animateShow()
      } else {
        this.animate = false
      }
    }
  },

  mounted () {
    if (this.visible) this.animateShow()
  },

  methods: {
    animateShow () {
      setTimeout(() => {
        this.animate = true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.custom-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,.8);
  overflow-y: auto;
  opacity: 0;
  transition: all .3s;
  &.animate {
    opacity: 1;
  }
  .dialog-card {
    position: relative;
    width: 625px;
    margin: 1.22rem auto;
    border-radius: 6px;
    background-color: #fff;
    &.center{
      margin: 3.5rem auto;
    }
    .btn-close {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -15px;
      right: -15px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 2px solid #fff;
      background-color: #4a4a4a;
      cursor: pointer;
      & .icon {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
